import {
  RecruitmentOffer,
  RecruitmentOfferDetail,
} from 'types/recruitment_offer'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { PaginationParameter } from '../common/pagination'

const resource = 'recruitment_offers'

export const requests = {
  fechRecruitmentOffers: async (
    params?: {
      worker_name?: string
    } & PaginationParameter,
  ) => {
    return await axiosForGigbaseBiz.get<DataResponse<RecruitmentOffer[]>>(
      resource,
      { params: params },
    )
  },
  fechRecruitmentOffer: async (id: string) => {
    return await axiosForGigbaseBiz.get<DataResponse<RecruitmentOfferDetail>>(
      `${resource}/${id}`,
    )
  },
}
